import { FC } from 'react'
import { styled } from '../../../../stitches.config'
import HeaderCtaButtons from './HeaderCtaButtons'
import HeaderNetworkImages from './HeaderNetworkImages'
import HeaderUserMenu from './HeaderUserMenu'
import LogoLink from './LogoLink'
import MobileNavDrawer from './MobileNavDrawer'
import NavigationMenuWithHover from './NavigationMenuWithHover'
import desktopNavData from '../../../../../public/desktopNavMenuData.json'
import desktopNavCorporateData from '../../../../../public/desktopNavMenuCorporateData.json'
import mobileNavData from '../../../../../public/mobileNavMenuData.json'
import mobileNavCorporateData from '../../../../../public/mobileNavMenuCorporateData.json'

const HeaderWrapper = styled('header', {
    backgroundColor: '$white',
    padding: '0',
    color: '$dark',
    fontSize: '3',
    position: 'relative',
    zIndex: 2,
})
const HeaderTop = styled('div', {
    '@md': {
        height: 95,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        px: '10vw',
    },
})
const HeaderTopContentLeft = styled('div', {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
})
const HeaderTopContentRight = styled('div', {
    display: 'none',
    '@md': {
        display: 'flex',
        justifyContent: 'right',
    },
})
const HeaderBottom = styled('div', {
    display: 'none',
    '@md': {
        display: 'flex',
        position: 'relative',
        width: '100%',
    },
})

const Header: FC<{ isCorporate: boolean }> = ({ isCorporate }) => {
    const mobileNavItems = isCorporate ? mobileNavCorporateData : mobileNavData
    const desktopNavItems = isCorporate
        ? desktopNavCorporateData
        : desktopNavData

    return (
        <HeaderWrapper>
            <HeaderTop>
                <HeaderTopContentLeft>
                    <MobileNavDrawer mobileNavItems={mobileNavItems} />
                    <LogoLink isCorporate={isCorporate} />
                </HeaderTopContentLeft>
                <HeaderTopContentRight>
                    <HeaderNetworkImages />
                    <HeaderUserMenu isCorporate={isCorporate} />
                    <HeaderCtaButtons isCorporate={isCorporate} />
                </HeaderTopContentRight>
            </HeaderTop>
            <HeaderBottom>
                <NavigationMenuWithHover menuData={desktopNavItems} />
            </HeaderBottom>
        </HeaderWrapper>
    )
}

export default Header
